import * as i2 from '@acorex/components/common';
import { MXBaseComponent, AXClosbaleComponent, AXCommonModule, AXHotkeysService } from '@acorex/components/common';
import * as i1 from '@angular/cdk/dialog';
import { DIALOG_DATA, Dialog, DialogModule } from '@angular/cdk/dialog';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, HostBinding, inject, Injectable, NgModule } from '@angular/core';
import * as i3 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i4 from '@acorex/components/button';
import { AXButtonModule } from '@acorex/components/button';
import * as i5 from '@acorex/components/decorators';
import { AXDecoratorModule } from '@acorex/components/decorators';
import * as i6 from '@acorex/components/loading';
import { AXLoadingModule } from '@acorex/components/loading';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from '@acorex/core/translation';
import { AXTranslationModule } from '@acorex/core/translation';
import { A11yModule } from '@angular/cdk/a11y';

class AXDialogComponent extends MXBaseComponent {
    /**
     *  @ignore
     */
    constructor(data, dialogRef) {
        super();
        this.data = data;
        this.dialogRef = dialogRef;
    }
    _handleButtonClick(button) {
        if (button.onClick) {
            button.onClick({ source: button });
        }
    }
    _hasAutoFocus(button) {
        const result = button.autofocus || this.data.buttons.length == 1 || !this.data.buttons.some((c) => c.autofocus);
        return result;
    }
    close() {
        this.dialogRef.close();
    }
    get tabIndex() {
        return '-1';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogComponent, deps: [{ token: DIALOG_DATA }, { token: i1.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.0.2", type: AXDialogComponent, selector: "ax-dialog", host: { properties: { "attr.tabIndex": "this.tabIndex" } }, providers: [
            {
                provide: AXClosbaleComponent,
                useExisting: AXDialogComponent,
            },
        ], usesInheritance: true, ngImport: i0, template: "<div class=\"ax-dialog ax-{{ data.type }}-default ax-orientation-{{ data.orientation }}\" cdkDrag cdkDragHandle\n  tabindex=\"-1\">\n  <div class=\"ax-dialog-content-wrapper\">\n    @if(data.icon !== 'none'){\n    <div class=\"ax-dialog-icon-side\">\n      <i class=\"ax-dialog-icon {{ data.icon }}\"></i>\n    </div>\n    }\n    <div class=\"ax-dialog-content-side\">\n      <div class=\"ax-dialog-title\">{{ data.title }}</div>\n      <div class=\"ax-dialog-content\">{{ data.content }}</div>\n    </div>\n    <div class=\"ax-dialog-dismiss-icon\">\n      @if(data.closeButton){\n      <i class=\"ax-icon ax-icon-close\"></i>\n      }\n    </div>\n  </div>\n  <ax-footer>\n    @for(button of data.buttons; let i = $index; track i){\n    <ax-button [text]=\"button.text | translate | async \" [tabindex]=\"i\" [axHotkey]=\"button.hotkey\"\n      [axAutoFocus]=\"_hasAutoFocus(button)\" (onClick)=\"_handleButtonClick(button)\" [look]=\"button.look\"\n      [disabled]=\"button.disabled\" [color]=\"button.color\">\n      @if(button.loading){\n      <ax-loading></ax-loading>\n      }\n    </ax-button>\n    }\n\n  </ax-footer>\n</div>", styles: [".ax-dark .ax-dialog.ax-primary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-primary-200));color:rgba(var(--ax-color-primary-fore-tint))}.ax-dark .ax-dialog.ax-secondary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-secondary-200));color:rgba(var(--ax-color-secondary-fore-tint))}.ax-dark .ax-dialog.ax-success-default .ax-dialog-icon{background-color:rgba(var(--ax-color-success-200));color:rgba(var(--ax-color-success-fore-tint))}.ax-dark .ax-dialog.ax-warning-default .ax-dialog-icon{background-color:rgba(var(--ax-color-warning-200));color:rgba(var(--ax-color-warning-fore-tint))}.ax-dark .ax-dialog.ax-danger-default .ax-dialog-icon{background-color:rgba(var(--ax-color-danger-200));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dark .ax-dialog.ax-info-default .ax-dialog-icon{background-color:rgba(var(--ax-color-info-200));color:rgba(var(--ax-color-info-fore-tint))}.ax-dialog{position:relative;display:flex;width:93vw;flex-direction:column;overflow:hidden;border-radius:var(--ax-rounded-border-default);border-width:1px;background-color:rgba(var(--ax-color-surface));color:rgba(var(--ax-color-surface-fore));outline:2px solid transparent;outline-offset:2px}@media (min-width: 768px){.ax-dialog{width:75vw}}@media (min-width: 1024px){.ax-dialog{width:50vw}}@media (min-width: 1280px){.ax-dialog{width:35vw}}@media (min-width: 1536px){.ax-dialog{width:25vw}}.ax-dialog.ax-orientation-horizontal .ax-dialog-content-wrapper{flex-direction:row}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper{flex-direction:column;align-items:center}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper .ax-dialog-icon-side{margin-bottom:1rem}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper .ax-dialog-content-side{margin:0;text-align:center}.ax-dialog.ax-orientation-vertical ax-footer ax-button{flex:1 1 0%}.ax-dialog .ax-dialog-content-wrapper{display:flex;gap:.5rem;padding:1.5rem 1.5rem 1rem}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-icon-side .ax-dialog-icon{display:flex;height:3rem;width:3rem;cursor:move;align-items:center;justify-content:center;border-radius:9999px;font-size:1.5rem;line-height:2rem}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side{margin-inline-start:1rem;flex:1 1 0%}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side .ax-dialog-title{margin-bottom:.5rem;font-size:1.125rem;line-height:1.5rem;font-weight:500}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side .ax-dialog-content{font-size:.875rem;line-height:1.25rem}.ax-dialog ax-footer{justify-content:flex-end;padding:.75rem 1.5rem}.ax-dialog.ax-primary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-primary-100));color:rgba(var(--ax-color-primary-fore-tint))}.ax-dialog.ax-secondary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-secondary-100));color:rgba(var(--ax-color-secondary-fore-tint))}.ax-dialog.ax-success-default .ax-dialog-icon{background-color:rgba(var(--ax-color-success-100));color:rgba(var(--ax-color-success-fore-tint))}.ax-dialog.ax-warning-default .ax-dialog-icon{background-color:rgba(var(--ax-color-warning-100));color:rgba(var(--ax-color-warning-fore-tint))}.ax-dialog.ax-danger-default .ax-dialog-icon{background-color:rgba(var(--ax-color-danger-100));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dialog.ax-info-default .ax-dialog-icon{background-color:rgba(var(--ax-color-info-100));color:rgba(var(--ax-color-info-fore-tint))}\n"], dependencies: [{ kind: "directive", type: i2.AXAutoFocusDirective, selector: "[axAutoFocus]", inputs: ["axAutoFocus", "axAutoFocusTime"] }, { kind: "directive", type: i2.AXHotkeyDirective, selector: "[axHotkey]", inputs: ["axHotkey"] }, { kind: "directive", type: i3.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i3.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "component", type: i4.AXButtonComponent, selector: "ax-button", inputs: ["disabled", "size", "tabIndex", "color", "look", "text", "toggleable", "selected", "type", "loadingText"], outputs: ["onBlur", "onFocus", "onClick", "selectedChange", "toggleableChange", "lookChange", "colorChange", "disabledChange", "loadingTextChange"] }, { kind: "component", type: i5.AXDecoratorGenericComponent, selector: "ax-footer, ax-header, ax-content, ax-divider, ax-form-hint, ax-prefix, ax-suffix, ax-text, ax-title, ax-sub-title, ax-placeholder, ax-overlay" }, { kind: "component", type: i6.AXLoadingComponent, selector: "ax-loading", inputs: ["visible", "type", "context"], outputs: ["visibleChange"] }, { kind: "pipe", type: i7.AsyncPipe, name: "async" }, { kind: "pipe", type: i8.AXTranslatorPipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ax-dialog', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: AXClosbaleComponent,
                            useExisting: AXDialogComponent,
                        },
                    ], template: "<div class=\"ax-dialog ax-{{ data.type }}-default ax-orientation-{{ data.orientation }}\" cdkDrag cdkDragHandle\n  tabindex=\"-1\">\n  <div class=\"ax-dialog-content-wrapper\">\n    @if(data.icon !== 'none'){\n    <div class=\"ax-dialog-icon-side\">\n      <i class=\"ax-dialog-icon {{ data.icon }}\"></i>\n    </div>\n    }\n    <div class=\"ax-dialog-content-side\">\n      <div class=\"ax-dialog-title\">{{ data.title }}</div>\n      <div class=\"ax-dialog-content\">{{ data.content }}</div>\n    </div>\n    <div class=\"ax-dialog-dismiss-icon\">\n      @if(data.closeButton){\n      <i class=\"ax-icon ax-icon-close\"></i>\n      }\n    </div>\n  </div>\n  <ax-footer>\n    @for(button of data.buttons; let i = $index; track i){\n    <ax-button [text]=\"button.text | translate | async \" [tabindex]=\"i\" [axHotkey]=\"button.hotkey\"\n      [axAutoFocus]=\"_hasAutoFocus(button)\" (onClick)=\"_handleButtonClick(button)\" [look]=\"button.look\"\n      [disabled]=\"button.disabled\" [color]=\"button.color\">\n      @if(button.loading){\n      <ax-loading></ax-loading>\n      }\n    </ax-button>\n    }\n\n  </ax-footer>\n</div>", styles: [".ax-dark .ax-dialog.ax-primary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-primary-200));color:rgba(var(--ax-color-primary-fore-tint))}.ax-dark .ax-dialog.ax-secondary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-secondary-200));color:rgba(var(--ax-color-secondary-fore-tint))}.ax-dark .ax-dialog.ax-success-default .ax-dialog-icon{background-color:rgba(var(--ax-color-success-200));color:rgba(var(--ax-color-success-fore-tint))}.ax-dark .ax-dialog.ax-warning-default .ax-dialog-icon{background-color:rgba(var(--ax-color-warning-200));color:rgba(var(--ax-color-warning-fore-tint))}.ax-dark .ax-dialog.ax-danger-default .ax-dialog-icon{background-color:rgba(var(--ax-color-danger-200));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dark .ax-dialog.ax-info-default .ax-dialog-icon{background-color:rgba(var(--ax-color-info-200));color:rgba(var(--ax-color-info-fore-tint))}.ax-dialog{position:relative;display:flex;width:93vw;flex-direction:column;overflow:hidden;border-radius:var(--ax-rounded-border-default);border-width:1px;background-color:rgba(var(--ax-color-surface));color:rgba(var(--ax-color-surface-fore));outline:2px solid transparent;outline-offset:2px}@media (min-width: 768px){.ax-dialog{width:75vw}}@media (min-width: 1024px){.ax-dialog{width:50vw}}@media (min-width: 1280px){.ax-dialog{width:35vw}}@media (min-width: 1536px){.ax-dialog{width:25vw}}.ax-dialog.ax-orientation-horizontal .ax-dialog-content-wrapper{flex-direction:row}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper{flex-direction:column;align-items:center}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper .ax-dialog-icon-side{margin-bottom:1rem}.ax-dialog.ax-orientation-vertical .ax-dialog-content-wrapper .ax-dialog-content-side{margin:0;text-align:center}.ax-dialog.ax-orientation-vertical ax-footer ax-button{flex:1 1 0%}.ax-dialog .ax-dialog-content-wrapper{display:flex;gap:.5rem;padding:1.5rem 1.5rem 1rem}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-icon-side .ax-dialog-icon{display:flex;height:3rem;width:3rem;cursor:move;align-items:center;justify-content:center;border-radius:9999px;font-size:1.5rem;line-height:2rem}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side{margin-inline-start:1rem;flex:1 1 0%}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side .ax-dialog-title{margin-bottom:.5rem;font-size:1.125rem;line-height:1.5rem;font-weight:500}.ax-dialog .ax-dialog-content-wrapper .ax-dialog-content-side .ax-dialog-content{font-size:.875rem;line-height:1.25rem}.ax-dialog ax-footer{justify-content:flex-end;padding:.75rem 1.5rem}.ax-dialog.ax-primary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-primary-100));color:rgba(var(--ax-color-primary-fore-tint))}.ax-dialog.ax-secondary-default .ax-dialog-icon{background-color:rgba(var(--ax-color-secondary-100));color:rgba(var(--ax-color-secondary-fore-tint))}.ax-dialog.ax-success-default .ax-dialog-icon{background-color:rgba(var(--ax-color-success-100));color:rgba(var(--ax-color-success-fore-tint))}.ax-dialog.ax-warning-default .ax-dialog-icon{background-color:rgba(var(--ax-color-warning-100));color:rgba(var(--ax-color-warning-fore-tint))}.ax-dialog.ax-danger-default .ax-dialog-icon{background-color:rgba(var(--ax-color-danger-100));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dialog.ax-info-default .ax-dialog-icon{background-color:rgba(var(--ax-color-info-100));color:rgba(var(--ax-color-info-fore-tint))}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: i1.DialogRef }], propDecorators: { tabIndex: [{
                type: HostBinding,
                args: ['attr.tabIndex']
            }] } });

/**
 * The Button is a component which detects user interaction and triggers a corresponding event
 *
 * @category Components
 */
class AXDialogService {
    constructor() {
        this.dialog = inject(Dialog);
    }
    detectIcon(type) {
        let icon;
        switch (type) {
            case 'success':
                icon = 'ax-icon ax-icon-check';
                break;
            case 'danger':
                icon = 'ax-icon ax-icon-error';
                break;
            case 'warning':
                icon = 'ax-icon ax-icon-warning';
                break;
            default:
                icon = 'ax-icon ax-icon-info';
                break;
        }
        return icon;
    }
    /**
     *  Show an alert box with 'Okay' button.
     */
    alert(title, content, type = 'primary', orientation = 'horizontal') {
        return new Promise((resolve) => {
            const popup = this.open({
                title,
                type: type,
                content,
                icon: this.detectIcon(type),
                orientation,
                buttons: [
                    {
                        name: 'confirm',
                        text: 'okay',
                        color: type,
                        autofocus: true,
                        onClick: () => {
                            popup.close();
                            if (resolve) {
                                resolve();
                            }
                        },
                    },
                ],
            });
        });
    }
    /**
     *  Show a confirm box with 'Okay' & 'Cancel' buttons.
     */
    confirm(title, content, type = 'primary', orientation = 'horizontal') {
        return new Promise((resolve) => {
            const popup = this.open({
                title,
                content,
                type,
                icon: this.detectIcon(type),
                orientation,
                buttons: [
                    {
                        name: 'confirm',
                        text: 'okay',
                        color: type,
                        autofocus: true,
                        onClick: () => {
                            popup.close();
                            if (resolve) {
                                resolve({ result: true });
                            }
                        },
                    },
                    {
                        name: 'cancel',
                        text: 'cancel',
                        color: `ghost`,
                        onClick: () => {
                            popup.close();
                            if (resolve) {
                                resolve({ result: false });
                            }
                        },
                        hotkey: {
                            Escape: () => {
                                popup.close();
                                if (resolve) {
                                    resolve({ result: false });
                                }
                            },
                        },
                    },
                ],
            });
        });
    }
    /**
     *  Show a custom dialog box.
     */
    show(options) {
        return new Promise((resolve) => {
            const popup = this.open(options);
            options.orientation = options.orientation || 'horizontal';
            (options.icon = options.icon ?? this.detectIcon(options.type)),
                options.buttons?.forEach((b) => {
                    const orginalClick = b.onClick;
                    b.onClick = () => {
                        const e = { source: b, handled: false };
                        if (orginalClick) {
                            orginalClick(e);
                            if (e.handled) {
                                resolve({ name: b.name ?? b.text });
                            }
                            else {
                                popup.close();
                                resolve({ name: b.name ?? b.text });
                            }
                        }
                        else if (resolve) {
                            popup.close();
                            resolve({ name: b.name ?? b.text });
                        }
                        else {
                            popup.close();
                        }
                    };
                });
        });
    }
    open(config) {
        const dialogRef = this.dialog.open(AXDialogComponent, {
            data: config,
            role: 'alertdialog',
            ariaModal: true,
            restoreFocus: true,
            closeOnNavigation: true,
            closeOnDestroy: true,
            hasBackdrop: true,
            disableClose: true,
            panelClass: ['ax-animate-bounceIn', 'ax-animate-faster'],
        });
        return {
            close: () => {
                dialogRef.componentInstance?.close();
            },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogService, decorators: [{
            type: Injectable
        }] });

const COMPONENT = [AXDialogComponent];
const MODULES = [
    CommonModule,
    AXCommonModule,
    DragDropModule,
    A11yModule,
    AXButtonModule,
    AXDecoratorModule,
    AXLoadingModule,
    DialogModule,
    AXTranslationModule,
];
class AXDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.2", ngImport: i0, type: AXDialogModule, declarations: [AXDialogComponent], imports: [CommonModule,
            AXCommonModule,
            DragDropModule,
            A11yModule,
            AXButtonModule,
            AXDecoratorModule,
            AXLoadingModule,
            DialogModule,
            AXTranslationModule], exports: [AXDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogModule, providers: [AXDialogService, AXHotkeysService], imports: [MODULES] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...COMPONENT],
                    imports: [...MODULES],
                    exports: [...COMPONENT],
                    providers: [AXDialogService, AXHotkeysService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AXDialogComponent, AXDialogModule, AXDialogService };
